import BaseList from "./BaseList";
import BatchInput from "./BatchInput";
// import CheckBoxWrap from "./CheckBoxWrap";
import DataList from "./DataList";
import DataLoad from "./DataLoad";
import DataTable from "./DataTable";
// import DateTimeRanges from "./DateTimeRanges";
import Drag from "./Drag";
// import FileUpComp from "./FileUpComp";
// import GetMessageButton from "./GetMessageButton";
// import NumberRange from "./NumberRange";
import PowerfulBtn from "./PowerfulBtn";
// import SelectTable from "./SelectTable";
import QuickForm from "./QuickForm";
import SelectExtend from "./SelectExtend";
// import SelectTree from "./SelectTree";
// import SlotRender from "./SlotRender";
import TodoList from "./TodoList";
// import TodoTable from "./TodoTable";
// import TreeExtend from "./TreeExtend";
import loadDataMix, { loadDataProps } from "./commonMix/loadData/index";
import { requestHooks } from "./utils/request";
import * as props from "./utils/props";
import type { App } from "vue";
import type { Component } from "vue";
const componentsArr: Array<Component> = [
  BaseList,
  BatchInput,
  DataList,
  DataLoad,
  DataTable,
  // DateTimeRanges,
  Drag,
  // FileUpComp,
  // GetMessageButton,
  // CheckBoxWrap,
  // NumberRange,
  PowerfulBtn,
  // SelectTable,
  QuickForm,
  SelectExtend,
  // SelectTree,
  // SlotRender,
  TodoList,
  // TodoTable,
  // TreeExtend,
];

export const install = function (app: App): void {
  componentsArr.map((setComponent: Component) => {
    if (setComponent.name) {
      app.component(setComponent.name, setComponent);
    }
  });
};

export {
  loadDataMix,
  loadDataProps,
  requestHooks,
  BaseList,
  BatchInput,
  DataList,
  DataLoad,
  DataTable,
  // DateTimeRanges,
  // Drag,
  // FileUpComp,
  // GetMessageButton,
  // CheckBoxWrap,
  // NumberRange,
  PowerfulBtn,
  // SelectTable,
  QuickForm,
  SelectExtend,
  // SelectTree,
  // SlotRender,
  TodoList,
  // TodoTable,
  // TreeExtend,
  Drag,
  props,
};
export default {
  loadDataMix,
  loadDataProps,
  requestHooks,
  // BaseList,
  DataList,
  DataLoad,
  DataTable,
  // DateTimeRanges,
  Drag,
  // FileUpComp,
  // GetMessageButton,
  // CheckBoxWrap,
  // NumberRange,
  PowerfulBtn,
  // SelectTable,
  QuickForm,
  SelectExtend,
  // SelectTree,
  // SlotRender,
  TodoList,
  // TodoTable,
  // TreeExtend,
  install,
  props,
};
